export enum IStep {
    Identification = 1,
    Signature,
    CreateUser
}
